export const environment = {
  production: true,
  tokenKey: 'EXCISEBIHAR',
  socketURL : "/",
  apiURL:"/v1/",
  apiURLV2:"/v2/",
  encDensKey: "kjhlOi9+7klo9378/950olk+haqw239o",
  // commandURL : "https://www.excisetrack.transecur.com/", // -- prod
  commandURL : "www.betaexcisetrack.transecur.com/", //-- test
};
